'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { type MouseEventHandler, useState } from 'react';
import IconLikeBordered from '@/components/assets/icon_like_bordered.svg';
import IconLikeFilled from '@/components/assets/icon_like_filled.svg';
import VerifiedBadge from '@/components/VerifiedBadge';
import { useWorldCardContext } from '@/context/ViverseWorldCardContext';
import { useLikedRoom } from '@/hooks/useLikedRoom';
import { Link } from '@/i18n/navigation';
import { hasVerifiedCreatorBadge } from '@/lib/cms';
import { cn } from '@/lib/utils';
const MoreAction = dynamic(() => import('@/components/MoreAction'), {
  ssr: false
});
export default function ViverseWorldCardInfo() {
  const $ = _c(45);
  const {
    targetUrl,
    cardType,
    noAccess,
    customDesc,
    hideLiked,
    isCoOwnedRoom,
    showMoreAction,
    shareOnly,
    stopSetAsFeatured,
    moreActionContent,
    onAfterMutatingWorld,
    isClient,
    info,
    href
  } = useWorldCardContext();
  const {
    id,
    title,
    hubs_url,
    owner,
    is_liked,
    is_voucher_room,
    view_count
  } = info;
  const {
    isLiked,
    handleClickLike
  } = useLikedRoom(id || "", href || hubs_url || "/", is_liked);
  const [likeAnimationKey, setLikeAnimationKey] = useState(0);
  const hasActions = isClient && (!hideLiked || showMoreAction && !!id);
  let t0;
  if ($[0] !== handleClickLike) {
    t0 = event => {
      setLikeAnimationKey(_temp);
      handleClickLike(event);
    };
    $[0] = handleClickLike;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleAnimatedLikeClick = t0;
  let t1;
  if ($[2] !== title) {
    t1 = <span className="line-clamp-1 text-[14px] leading-[1.3] font-semibold text-[#eeeef0]">{title}</span>;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== targetUrl) {
    t2 = <Link href={targetUrl} prefetch={false} className="-my-1 flex min-h-6 items-center overflow-hidden py-1" draggable={false}>{t1}</Link>;
    $[4] = t1;
    $[5] = targetUrl;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleAnimatedLikeClick || $[8] !== hasActions || $[9] !== hideLiked || $[10] !== id || $[11] !== info || $[12] !== isCoOwnedRoom || $[13] !== isLiked || $[14] !== is_voucher_room || $[15] !== likeAnimationKey || $[16] !== moreActionContent || $[17] !== onAfterMutatingWorld || $[18] !== shareOnly || $[19] !== showMoreAction || $[20] !== stopSetAsFeatured) {
    t3 = hasActions && <div className="flex h-0 shrink-0 items-center gap-1 overflow-visible">{!hideLiked && <button type="button" className={cn("focus-visible:ring-vive-border-focus focus-visible:ring-offset-background hover:ring-0.5 relative flex size-7 cursor-pointer items-center justify-center rounded-full text-white/90 opacity-0 transition-[opacity,transform,background-color,color,box-shadow,backdrop-filter] duration-300 ease-out outline-none group-hover:opacity-100 hover:bg-white/10 hover:text-white hover:shadow-[0_10px_24px_rgba(18,18,22,0.28)] hover:ring-white/20 hover:backdrop-blur-md focus-visible:bg-white/10 focus-visible:text-white focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:backdrop-blur-md active:scale-95 active:bg-white/15", isLiked && "text-vive-brand-40 hover:text-vive-brand-40 focus-visible:text-vive-brand-40 opacity-100")} aria-label={isLiked ? "Unlike world" : "Like world"} aria-pressed={isLiked} onClick={handleAnimatedLikeClick}><span key={`like-icon-${likeAnimationKey}`} className={cn("relative z-10 flex size-5 items-center justify-center", likeAnimationKey > 0 && "motion-safe:animate-[like-icon-pop_420ms_cubic-bezier(0.2,1.4,0.28,1)_both] motion-reduce:animate-none")}>{isLiked ? <IconLikeFilled className="size-5 p-0.5" /> : <IconLikeBordered className="size-5 p-0.5" />}</span></button>}{showMoreAction && id && <div className="flex items-center"><MoreAction info={info} shareOnly={shareOnly} isCoOwnedRoom={isCoOwnedRoom} onAfterMutatingWorld={onAfterMutatingWorld} stopSetAsFeatured={stopSetAsFeatured} isPremiumRoom={!!is_voucher_room} triggerClassName="focus-visible:ring-vive-border-focus focus-visible:ring-offset-background hover:ring-0.5 relative flex size-7 cursor-pointer items-center justify-center rounded-full text-white/90 opacity-0 transition-[opacity,transform,background-color,color,box-shadow,backdrop-filter] duration-300 ease-out outline-none group-hover:opacity-100 hover:bg-white/10 hover:text-white hover:shadow-[0_10px_24px_rgba(18,18,22,0.28)] hover:ring-white/20 hover:backdrop-blur-md hover:[&_path]:fill-white focus-visible:bg-white/10 focus-visible:text-white focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:backdrop-blur-md focus-visible:[&_path]:fill-white active:scale-95 active:bg-white/15 [&_path]:fill-white/90 [&_path]:transition-colors [&_path]:duration-300 [&_path]:ease-out" iconClassName="size-5 p-0.5 transition-colors duration-300">{moreActionContent}</MoreAction></div>}</div>;
    $[7] = handleAnimatedLikeClick;
    $[8] = hasActions;
    $[9] = hideLiked;
    $[10] = id;
    $[11] = info;
    $[12] = isCoOwnedRoom;
    $[13] = isLiked;
    $[14] = is_voucher_room;
    $[15] = likeAnimationKey;
    $[16] = moreActionContent;
    $[17] = onAfterMutatingWorld;
    $[18] = shareOnly;
    $[19] = showMoreAction;
    $[20] = stopSetAsFeatured;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== t2 || $[23] !== t3) {
    t4 = <div className="flex items-center justify-between gap-2">{t2}{t3}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  const t5 = `/profile/${owner?.community_user_id}`;
  let t6;
  if ($[25] !== noAccess) {
    t6 = cn("text-vive-primary-30 flex min-h-6 max-w-full items-center gap-1 self-start overflow-hidden text-[12px] leading-[1.3] tracking-[0.15px] whitespace-nowrap transition-colors duration-300 hover:text-white hover:underline", {
      invisible: noAccess
    });
    $[25] = noAccess;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  const t7 = customDesc ?? owner?.display_name;
  let t8;
  if ($[27] !== t7) {
    t8 = <span className="truncate">{t7}</span>;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== owner) {
    t9 = hasVerifiedCreatorBadge(owner);
    $[29] = owner;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t9) {
    t10 = <VerifiedBadge isVerified={t9} />;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t5 || $[35] !== t6 || $[36] !== t8) {
    t11 = <Link href={t5} prefetch={false} className={t6} draggable={false}>{t8}{t10}</Link>;
    $[33] = t10;
    $[34] = t5;
    $[35] = t6;
    $[36] = t8;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== cardType || $[39] !== view_count) {
    t12 = cardType === "videos" && view_count !== undefined && <p className="text-vive-primary-30 text-[12px] tracking-[0.15px]">{view_count.toLocaleString()} views</p>;
    $[38] = cardType;
    $[39] = view_count;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t4) {
    t13 = <div className="flex flex-col gap-0.5 px-0.5 pt-1">{t4}{t11}{t12}</div>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t4;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
}
function _temp(k) {
  return k + 1;
}